import { Component, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { MegaMenuItem } from 'primeng/api';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-topbar',
  imports: [NgIf, NgFor, RouterLink, ButtonModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent implements OnInit {
  items: MegaMenuItem[] = [];
  mobileMenuOpen = false;

  ngOnInit() {
    this.items = [
      {
        label: 'Home',
        url : '/'
      },
      {
        label: 'Contact',
        url: '/contact'
      }
    ];
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    
    // Prevent body scroll when menu is open
    if (this.mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
    document.body.style.overflow = '';
  }
}
